import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { AzureMapService } from "@rubbl-azure-maps";
import { AzureSearchResult } from "@rubbl-azure-search";
import { CartService } from "@rubbl-cart";
import { ShareService, LogService, SearchResult, LocalStorageService } from "@rubbl-core";
import { DropDownItem } from "@rubbl-forms";
import { InventoryItem } from "@rubbl-inventory";
import { MarketingCard } from "@rubbl-marketing";
import { SearchRequest, SearchResultsService } from "@rubbl-search-results";

import { Subscription } from "rxjs";

@Component({
  selector: "app-search-results-grid-layout",
  templateUrl: "./search-results-grid-layout.component.html",
  styleUrls: ["./search-results-grid-layout.component.scss"],
})
export class SearchResultsGridLayoutComponent implements OnInit, OnDestroy {
  @ViewChild("paginator") paginator: MatPaginator;

  searchResults: AzureSearchResult<InventoryItem>;
  mockSearchRequest: SearchRequest = new SearchRequest();
  selectedOrderBy: string;
  orderByDropDownItems: DropDownItem[] = this.searchResultsService.searchRequest.orderBy.options;

  searchResultsSubscription: Subscription;
  navigationSubscription: Subscription;

  cartSubscription: Subscription;
  machineIdsInCart: string[] = [];
  filteredAttachments: string[] = [];
  pageIndex: number = 0;

  testimonialIframeIdPrefix: string = "testimonialto-embed-text-";
  testimonialIframeIdComplete: any;
  testimonialIds = [
    "-O9udtUSNJx_R6qpjeox",
    "-O9u_PW4NKR7l3Hm8_Ie",
    "-O9uOMp-3xCxix191XwF",
    "-O9u5oKcLhhlGprLjifw",
    "-O9WYybNiD8yl6WxlmVt",
    "-O9Sk1GzvuT2zdzzokja",
  ];
  testimonialUrl: string;

  alreadyReasized: boolean;
  cityState: string;
  searchTerm: string;
  constructor(
    private searchResultsService: SearchResultsService,
    private router: Router,
    private route: ActivatedRoute,
    private shareService: ShareService,
    private cartService: CartService,
    private logService: LogService,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService,
    private azureMapService: AzureMapService,
  ) {}

  ngOnInit() {
    this.rentalVisit();
    // subscribe to search results for constant updates
    this.searchResultsSubscription = this.searchResultsService.searchResults$.subscribe((results: AzureSearchResult<InventoryItem>) => {
      // the following is a bull shit check I could not figure out why when going from map view to list view that it would show the 28 results for the first page which all the properties
      // THEN it would show the 1000 results of the map with just a select few properties. because on the map view the only properties we query for is like gps long lat
      if (results) {
        if (results.value?.length > 0) {
          if (!("rentalRate" in results.value[0])) {
            return;
          }
        }
      }

      if (this.searchResultsService?.searchRequest?.attachment?.specs?.facets) {
        this.filteredAttachments = this.searchResultsService.searchRequest.attachment.specs.facets
          .filter(d => {
            // this d.label check is for selecting attachment catalogs on the machine card
            // sometimes an attachment catalog has no specs
            if (d.label == "") {
              return true;
            }
            if (d.label != "" && d.checked) {
              return true;
            } else {
              return false;
            }
          })
          .map(d => {
            return d.parentValue + "|" + d.label;
          });
      }

      this.searchResults = results;
      if (results) {
        const randomTestimonialId = this.testimonialIds[Math.floor(Math.random() * this.testimonialIds.length)];
        this.testimonialIframeIdComplete = this.sanitizer.bypassSecurityTrustResourceUrl(`https://embed-v2.testimonial.to/text/${randomTestimonialId}`);
        if (!this.alreadyReasized) {
          this.alreadyReasized = true;
          this.resizeIframes();
        }
      }
      this.selectedOrderBy = this.searchResultsService.searchRequest.orderBy.getFromQueryParam();
      this.pageIndex = this.searchResultsService.searchRequest.pageIndex;
      this.cityState = this.searchResultsService.searchRequest.location.toCityState();

      if (results != null) {
        this.searchResultsService.updateMetaTags();
        this.logService.sendGoogleEcommerceView("view_item_list", results.value, "1", "search_results");
      }
    });

    let searchTerm = this.route.snapshot.queryParamMap.get("q") || "all";
    let cityState = this.route.snapshot.paramMap.get("cityState") || "";

    this.searchTerm = searchTerm;

    const locationFromStorage = this.localStorageService.get(`location-${cityState}`);
    if (!locationFromStorage && cityState) {
      this.azureMapService.geoCodeNinja(cityState).subscribe(location => {
        this.mockSearchRequest.location.newFilter(location);
        this.localStorageService.set(`location-${cityState}`, location);
        this.continueSearchAfterFiguringLocation();
      });
      return;
    }

    this.mockSearchRequest.location.newFilter(locationFromStorage);
    this.continueSearchAfterFiguringLocation();

    this.cartSubscription = this.cartService.cartBSubject.subscribe(d => {
      this.machineIdsInCart = d?.items.map(d => d.id) || [];
    });
  }

  continueSearchAfterFiguringLocation() {
    let searchTerm = this.route.snapshot.queryParamMap.get("q") || null;
    if (searchTerm) {
      searchTerm = searchTerm.replace(/-/g, " ");
    }
    this.searchTerm = searchTerm;

    let primaryType = this.route.snapshot.paramMap.get("primaryType") || null;

    this.searchResultsService.search(searchTerm, this.mockSearchRequest.location, primaryType, this.searchResultsService.currentPageSize, true);

    // we need to subscribe to route changes to start the search since the filter results is just a route change
    // can probably rework this to be a bit better
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationStart) {
        this.searchResults = null;
      }

      if (e instanceof NavigationEnd) {
        let searchTerm = this.route.snapshot.queryParamMap.get("q") || null;
        let cityState = this.route.snapshot.paramMap.get("cityState") || "";
        let primaryType = this.route.snapshot.paramMap.get("primaryType") || null;

        this.searchTerm = searchTerm;
        if (searchTerm) {
          searchTerm = searchTerm.replace(/-/g, " ");
        }

        const locationFromStorage = this.localStorageService.get(`location-${cityState}`);
        if (!locationFromStorage && cityState) {
          this.azureMapService.geoCodeNinja(cityState).subscribe(location => {
            this.mockSearchRequest.location.newFilter(location);
            this.localStorageService.set(`location-${cityState}`, location);
            this.searchResultsService.search(searchTerm, this.mockSearchRequest.location, primaryType);
            this.rentalVisit();
            this.resizeIframes();
          });
          return;
        }

        this.mockSearchRequest.location.newFilter(locationFromStorage);
        this.searchResultsService.search(searchTerm, this.mockSearchRequest.location, primaryType);
        this.rentalVisit();
        this.resizeIframes();
      }
    });
  }

  resizeIframes() {
    setTimeout(() => {
      try {
        window["iFrameResize"]({ log: false, checkOrigin: false, warningTimeout: 0 }, "#testimonialto-carousel-rubbl-homepage-tag-all-light");
        window["iFrameResize"]({ log: false, checkOrigin: false, warningTimeout: 0 }, "#testimonialto-embed-text--OA-qLoMri0zWh_Yidf7");
      } catch (e) {}
    }, 800);
  }
  ngOnDestroy(): void {
    this.navigationSubscription?.unsubscribe();
    this.searchResultsSubscription?.unsubscribe();
    this.cartSubscription?.unsubscribe();
  }

  get showS() {
    if (this.searchTerm && !this.searchTerm.endsWith("s")) {
      return "s";
    }

    return "";
  }
  getNumberOfPages() {
    if (!this.paginator) {
      return;
    }

    return this.paginator.getNumberOfPages();
  }

  filterResults() {
    this.searchResultsService.filterResults();
  }

  lastMachineCardShown() {
    this.searchResultsService.nextPage();
  }

  handlePageEvent(event: PageEvent | number | any) {
    this.searchResultsService.paginate(event.pageIndex);
  }

  shareResults() {
    this.shareService.share("Rubbl Search Results", "Take a look at these machines on Rubbl.", window.location.href, { target: "searchResults" });
  }

  rentalVisit() {
    this.logService.trackEvent(
      "rentalSearchVisit",
      {
        event: "rentalSearchVisit",
      },
      true,
    );
  }

  rentingInfoCards: MarketingCard[] = [
    {
      iconClass: "icon-date-time",
      title: "What is the minimum rental duration?",
      body: "One week minimum, discounts are available for long term rentals starting at 3 months.",
    },
    {
      iconClass: "icon-earnings",
      title: "When do I pay?",
      body:
        "For most customers, advanced payment is required before the rental start date. For larger companies, we offer terms with a simple credit application.",
    },
    {
      iconClass: "icon-transpo",
      title: "Who transports the machine?",
      body: "Rubbl coordinates the whole transportation process. Upon order placement, our coordinator will find you the cheapest transportation quote.",
    },
    {
      iconClass: "icon-lightning",
      title: "How fast can I get my machine?",
      body:
        "On order placement a series of renter background and equipment checks are performed. This is to protect the owner, renter, and Rubbl from fraudulent orders. The majority of deliveries happen within 1-2 days of the order being placed.",
    },
    // {
    //   iconClass: "icon-replacement",
    //   title: "What is your refund policy?",
    //   body: "Rubbl offers refunds within 24 hours if the equipment does not meet the specifications that were transacted on.",
    // },
    // {
    //   iconClass: "icon-right",
    //   title: "How do I return the machine?",
    //   body: "A dedicated, knowledgeable account manager will support you through every step of the rental process.",
    // },
  ];
}
